<template>
  <div id="publication-list">
    <!-- app drawer -->
    <v-dialog
      v-model="isFormActive"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 700 : '100%'"
    >
      <publication-form
        v-model="item"
        :is-form-active="isFormActive"
        :pay-options="payOptions"
        :plan-options="planOptions"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span
            class="font-weight-semibold text-base text--primary">{{ item.id ? $t('Modifier') : $t('Ajouter une publication')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isFormActive = !isFormActive"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:form-cancel>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="isFormActive = !isFormActive"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </publication-form>
    </v-dialog>
    <v-dialog
      v-model="signatureDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <signature-form
        v-model="item"
        :is-form-active="signatureDialog"
        :pay-options="payOptions"
        :plan-options="planOptions"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span
            class="font-weight-semibold text-base text--primary">{{ item.id ? $t('Modifier') : $t('Ajouter un publication')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="signatureDialog = !signatureDialog"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:form-cancel>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="signatureDialog = !signatureDialog"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </signature-form>
    </v-dialog>
    <v-dialog
      v-model="accordDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <accord-form
        v-model="item"
        :is-form-active="accordDialog"
        :pay-options="payOptions"
        :plan-options="planOptions"
        @refetch-data="fetchItems"
      >
        <template v-slot:form-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t('Accord Signature')
            }}</span>
          <v-spacer />
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="accordDialog = !accordDialog"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:form-cancel>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="accordDialog = !accordDialog"
          >
            {{ $t('Annuler') }}
          </v-btn>
        </template>
      </accord-form>
    </v-dialog>
    <v-dialog
      v-model="isbnDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <v-card>
        <v-card-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t('Attribution ISBN')
            }}</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div
                v-if="item.author && item.author.id"
                class="d-flex align-center"
              >
                <v-avatar
                  :color="item.author.avatar ? '' : 'primary'"
                  :class="item.author.avatar ? '' : 'v-avatar-light-bg primary--text'"
                  size="30"
                >
                  <v-img
                    v-if="item.author.avatar"
                    :lazy-src="require(`@/assets/images/avatars/2.png`)"
                    :src="item.author.avatar || require(`@/assets/images/avatars/2.png`)"
                  ></v-img>
                  <span
                    v-else
                    class="font-weight-medium"
                  >{{ avatarText(item.author.full_name) }}</span>
                </v-avatar>

                <div class="d-flex flex-column ms-3">
                  <router-link
                    :to="{ name : 'author-view', params : { id : item.author_id } }"
                    class="text--primary font-weight-semibold text-truncate cursor-pointer text-decoration-none"
                  >
                    {{ item.author.full_name }}
                  </router-link>
                  <small v-if="item.manuscript && item.manuscript.id">{{ item.manuscript.title
                    }}</small>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              {{ $t('Confirmez-vous l\'attribution d\'un ISBN à ce dossier ?') }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            :loading="loading"
            color="secondary"
            outlined
            type="reset"
            @click="isbnDialog = false"
          >
            {{ $t('Annuler') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="loading"
            color="primary"
            class="me-3"
            @click="attributeIsbn(item)"
          >
            {{ $t('Confirmer') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="titleDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 500 : '100%'"
    >
      <v-card>
        <v-card-title>
          <span class="font-weight-semibold text-base text--primary">{{ $t('Modification du titre')
            }}</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div
                v-if="item.author && item.author.id"
                class="d-flex align-center"
              >
                <v-avatar
                  :color="item.author.avatar ? '' : 'primary'"
                  :class="item.author.avatar ? '' : 'v-avatar-light-bg primary--text'"
                  size="30"
                >
                  <v-img
                    v-if="item.author.avatar"
                    :lazy-src="require(`@/assets/images/avatars/2.png`)"
                    :src="item.author.avatar || require(`@/assets/images/avatars/2.png`)"
                  ></v-img>
                  <span
                    v-else
                    class="font-weight-medium"
                  >{{ avatarText(item.author.full_name) }}</span>
                </v-avatar>

                <div class="d-flex flex-column ms-3">
                  <router-link
                    :to="{ name : 'author-view', params : { id : item.author_id } }"
                    class="text--primary font-weight-semibold text-truncate cursor-pointer text-decoration-none"
                  >
                    {{ item.author.full_name }}
                  </router-link>
                  <small v-if="item.manuscript && item.manuscript.id">{{ item.manuscript.title
                    }}</small>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              {{ $t('Confirmez-vous la modification du titre ?') }}
            </v-col>
            <v-col
              v-if="titleDialog"
              cols="12"
            >
              <v-text-field
                v-model="item.title"
                outlined
                dense
                :label="$t('Titre')"
                :placeholder="$t('Titre')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.comment"
                outlined
                rows="2"
                auto-grow
                dense
                :label="$t('Commentaire')"
                :placeholder="$t('Commentaire')"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            :loading="loading"
            color="secondary"
            outlined
            type="reset"
            @click="titleDialog = false"
          >
            {{ $t('Annuler') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="loading"
            color="primary"
            class="me-3"
            @click="changeTitle(item)"
          >
            {{ $t('Confirmer') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- list filters -->
    <v-card>
      <v-card-title>
        {{ $t('Publications') }}
        <v-chip
          outlined
          class="ml-2"
        >
          {{ totalItems }}
        </v-chip>
        <v-spacer />
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-spacer />
        <v-text-field
          v-model="$store.state.app.settings.publication_value"
          hide-details
          class="me-3"
          style="max-width: 150px;"
          dense
          outlined
          :readonly="!$can('edit_indicator','Publication')"
          @change="updateSettings"
        ></v-text-field>
        <export-excel
          v-if="$can('download','Publication')"
          :options="downloadObject"
          @refetch-data="() => fetchItems(true, 'publication')"
        />
      </v-card-title>
      <!-- table -->
      <v-data-table
        v-model="selectedRows"
        class="fixed-table"
        :headers="tableColumns"
        :items="items"
        :options.sync="options"
        :page.sync="page"
        :server-items-length="totalItems"
        :loading="loading"
        :loading-text="$t('Chargement des éléments')"
        :no-data-text="$t('Pas de données')"
        :no-results-text="$t('Aucun résultat')"
        hide-default-footer
        :show-select="false"
        dense
        fixed-header
        :height="tableHeight"
        :footer-props="{
          'items-per-page-options': rowsPerPageItems
        }"
        @page-count="pageCount = $event"
      >
        <template #body.prepend="{ items, headers }">
          <header-filters :headers="filters" />
        </template>
        <template #item="options">
          <Row :options="options"
               :config="{ url: '/publications/action/', author: 'author', manuscript: 'manuscript', resource: 'Publication'}"
               @refetch-data="fetchItems"

          >
            <template #[`item.is_reading`]="{item}">
              <v-icon
                v-if="item.is_reading"
                small
                color="success"
              >
                {{ icons.mdiCheckCircle }}
              </v-icon>
            </template>
            <!-- name -->
            <template #[`item.author.full_name`]="{item}">
              <author-widget :object="item.author"
                             :is-dossier-prioritaire="item.manuscript.priority" />
            </template>
            <template #[`item.author.old_author`]="{item}">
              <v-icon
                v-if="item.author && item.author.old_author"
                small
                color="success"
              >
                {{ icons.mdiCheckCircle }}
              </v-icon>
            </template>
            <template #[`item.author.published`]="{item}">
              <div class="text-center">
                <v-icon
                  v-if="item.published"
                  small
                  color="success"
                >
                  {{ icons.mdiCheckCircle }}
                </v-icon>
              </div>
            </template>
            <!-- pay -->
            <template #[`item.country`]="{item}">
              <div
                v-if="item.country"
                class="d-flex align-center"
              >
                <!--            <v-avatar
              size="30"
              :color="resolvePublicationRoleVariant(item.pay)"
              :class="`v-avatar-light-bg ${resolvePublicationRoleVariant(item.pay)}&#45;&#45;text me-3`"
            >
              <v-icon
                size="18"
                :color="resolvePublicationRoleVariant(item.pay.name)"
              >
                {{ resolvePublicationRoleIcon(item.pay.name) }}
              </v-icon>
            </v-avatar>-->
                <span class="text-capitalize">{{ item.country.name }}</span>
              </div>
            </template>

            <template #[`item.signature_date`]="{item}">
              <template v-if="item.signature_date && !item.signature_date.includes('0000')">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      style="cursor: pointer"
                      :class="{'text-red': item.state < 0 }"
                      v-bind="attrs"
                      v-on="on"
                    >{{ formatDate(item.signature_date || null, {
                      month: 'numeric',
                      day: 'numeric',
                      year: 'numeric',
                    }) }}</span>
                  </template>
                  <span
                    v-if="!item.publication_records || (item.publication_records.filter(el=>el.comment && el.type === 'signature').length === 0)">{{ ''
                    }}</span>
                  <template v-else>
                    <div>
                      <p
                        v-for="precord in item.publication_records.filter(el=>el.type === 'signature')"

                        :key="precord.id"
                      >
                        <span class="mr-2">{{ precord.user ? precord.user.code : '' }}</span>
                        <span
                          v-if="precord.date_record"
                          class="mr-2"
                        >{{ formatDate(precord.date_record || null, {
                          month: 'numeric',
                          day: 'numeric',
                          year: 'numeric',
                        }) }}</span>
                        <span class="mr-2">{{ precord.comment }}</span>
                      </p>
                    </div>
                  </template>
                </v-tooltip>
              </template>
            </template>

            <template #[`item.isbn`]="{item}">
              <span v-if="item.isbn && item.isbn.trim().length > 5">
                {{ item.isbn }}
              </span>
              <v-btn
                v-else
                x-small
                color="primary"
                text
                @click="openIsbnDialog(item)"
              >
                <v-icon color="primary">
                  {{ icons.mdiCheckboxMarkedCircleOutline }}
                </v-icon>
              </v-btn>
            </template>
            <template #[`item.title`]="{item}">
              <span
                style="cursor: pointer;"
                @click="openTitleDialog(item)"
              >
                <span v-if="item.manuscript && item.title">{{ item.title || '' }}</span>
                <v-icon
                  v-else
                  color="primary"
                >
                  {{ icons.mdiCheckboxMarkedCircleOutline }}
                </v-icon>
              </span>
            </template>
            <!-- status -->
            <template #[`item.status`]="{item}">
              <v-chip
                v-if="item.status && item.status.id"
                small
                :color="item.status.color"
                :class="`${item.status.color}--text`"
                class="v-chip-light-bg font-weight-semibold text-capitalize"
              >
                {{ item.status.name }}
              </v-chip>
              <!--          <publication-status-chip
            :object="item"
            @refetch-data="fetchPublications"
          />-->
            </template>
            <!-- status -->
            <!--        <template #[`item.price`]="{item}">-->
            <!--          <span>{{ item.price.toFixed(2)}}</span>-->
            <!--        </template>-->

            <!-- actions -->
            <template #[`item.actions`]="{item}">
              <!--
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on, attrs }">-->
              <v-btn
                v-if="$can('edit','Publication')"
                icon
                :disabled="isCompleted(item)"
                @click="openDialog(item)"
              >
                <v-icon>{{ icons.mdiPencilOutline }}</v-icon>
              </v-btn>
              <!--            </template>

            <v-list>-->
              <!--              <v-list-item
                :to="{name:'publication-view',params:{id:item.id}}"
              >
                <v-list-item-title>
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiFileDocumentOutline }}
                  </v-icon>
                  <span>{{ $t('Détails') }}</span>
                </v-list-item-title>
              </v-list-item>-->

              <!--              <v-list-item v-if="$can('edit','Publication')" @click="openDialog(item)">
                <v-list-item-title>
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiPencilOutline }}
                  </v-icon>
                  <span>{{ $t('Modifier') }}</span>
                </v-list-item-title>
              </v-list-item>-->
              <!--              <v-list-item v-if="!item.status_id" @click="openAccordDialog(item)">
                <v-list-item-title>
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiCheckOutline }}
                  </v-icon>
                  <span>{{ $t('Accord Signature') }}</span>
                </v-list-item-title>
              </v-list-item>-->
              <!--              <v-list-item @click="confirmDelete(item)">
                <v-list-item-title>
                  <v-icon
                    size="20"
                    class="me-2"
                  >
                    {{ icons.mdiDeleteOutline }}
                  </v-icon>
                  <span><span>{{ $t('Supprimer') }}</span></span>
                </v-list-item-title>
              </v-list-item>-->
              <!--            </v-list>
          </v-menu>-->
            </template>
          </Row>
        </template>
      </v-data-table>
      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <rows-per-page :options="options" />
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="page"
              total-visible="6"
              :length="pageCount"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
    >
      <v-card>
        <v-card-title>{{ $t('Confirmer la suppression') }}</v-card-title>
        <v-divider />
        <v-card-text>{{ $t('Confirmez-vous de vouloir supprimer') }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            small
            outlined
            @click="deleteDialog = false"
          >
            {{ $t('Non') }}
          </v-btn>
          <v-spacer />
          <v-btn
            small
            color="primary"
            :loading="loading"
            @click="deleteItem"
          >
            {{ $t('Oui') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarBottomVisible"
      :color="$vuetify.theme.currentTheme.error"
      :light="$vuetify.theme.dark"
    >
      {{ snackBarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiSquareEditOutline,
  mdiDotsVertical,
  mdiPlus,
  mdiClose,
  mdiFileDocumentOutline,
  mdiDeleteOutline,
  mdiExportVariant,
  mdiAccountOutline,
  mdiPencilOutline,
  mdiCheckCircle,
  mdiCheckOutline,
  mdiCheckboxMarkedCircleOutline,
} from '@mdi/js'
import { onUnmounted, ref } from '@vue/composition-api'

// sidebar
import { avatarText, formatDate } from '@core/utils/filter'
import axios from '@axios'
import store from '@/store'
import PublicationForm from './PublicationForm.vue'
import itemStoreModule from './itemStoreModule'

import controller from './Controller'
import RowsPerPage from '@/components/RowsPerPage'
import SignatureForm from '@/views/apps/publications/SignatureForm'
import AccordForm from '@/views/apps/publications/AccordForm'
import HeaderFilters from '@/components/HeaderFilters'
import ability from '@/plugins/acl/ability'
import ExportExcel from '@/components/ExportExcel'
import TableRow from '@/components/TableRow'
import Row from '@/components/Row'
import AuthorWidget from '@/views/apps/author/author-view/components/AuthorWidget.vue'

export default {
  components: {
    AuthorWidget,
    Row,
    TableRow,
    ExportExcel,
    HeaderFilters,
    AccordForm,
    SignatureForm,
    RowsPerPage,
    PublicationForm,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-publication'
    const assistants = ref([])

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, itemStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const {
      item,
      items,
      isbnDialog,
      signatureDialog,
      downloadObject,
      accordDialog,
      tableColumns,
      filters,
      searchQuery,
      payFilter,
      sourceFilter,
      statusFilter,
      totalItems,
      loading,
      options,
      rowsPerPageItems,
      publicationTotalLocal,
      selectedRows,
      isFormActive,
      snackBarMessage,
      isSnackbarBottomVisible,
      openDialog,
      openSignatureDialog,
      openAccordDialog,
      openIsbnDialog,
      titleDialog,
      openTitleDialog,
      deleteItem,
      deleteDialog,
      confirmDelete,
      fetchItems,
      tableHeight,
      attributeIsbn,
      changeTitle,
      resolvePublicationRoleVariant,
      resolvePublicationRoleIcon,
      resolvePublicationStatusVariant,
      resolvePublicationStatusName,
      resolvePublicationTotalIcon,
      showResiliation,
    } = controller()

    const superiors = ref([])

    const payOptions = [
      { title: 'Admin', value: 'admin' },
      { title: 'Publication', value: 'publication' },
      { title: 'Editor', value: 'editor' },
      { title: 'Maintainer', value: 'maintainer' },
      { title: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { title: 'Basic', value: 'basic' },
      { title: 'Company', value: 'company' },
      { title: 'Enterprise', value: 'enterprise' },
      { title: 'Standard', value: 'standard' },
    ]

    const statusOptions = [
      { title: 'Actif', value: 1 },
      { title: 'Inactif', value: 0 },
    ]
    store
      .dispatch('app-publication/fetchCountries', { per_page: 500 })
    store
      .dispatch('app-publication/fetchSources', { per_page: 500 })

    /* store
      .dispatch('app/fetchGenres', { per_page: 500 }) */

    /* store
      .dispatch('app/fetchFormats', { per_page: 500, type: 'publication' }) */
    store
      .dispatch('app-publication/fetchStatuses', { per_page: 500, status_type: 'publication' })

    filters.value = tableColumns
    axios
      .get('/formats', { params: { per_page: 500, type: 'publication' } })
      .then(response => {
        store.state['app/formats'] = response.data.data
        const indexH = filters.value.findIndex(ele => ele.value === 'format.name' && ele.format_type === 'Publication')
        if (indexH > 0) {
          filters.value[indexH].filter.values = response.data.data
        }
      })
      .catch(error => console.log(error))
    axios
      .get('/genres', { params: { per_page: 500, type: 'publication' } })
      .then(response => {
        store.state['app/genres'] = response.data.data
        const indexH = filters.value.findIndex(ele => ele.value === 'genre.label')
        if (indexH > 0) {
          filters.value[indexH].filter.values = response.data.data
        }
      })
      .catch(error => console.log(error))

    if (ability.can('assistant', 'Publication')) {
      axios
        .get('/listWorkers', {
          params: {
            term: '',
            type: 'publication',
            user: JSON.parse(localStorage.getItem('userData')).id || null,
            rowsPerPage: 100,
          },
        })
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            const u = response.data[i]
            const indexU = assistants.value.findIndex(el => el.id === u.id)
            if (indexU < 0) {
              assistants.value.push(u)
            }
          }
          const indexH = filters.value.findIndex(ele => ele.value === 'assistant.code')
          if (indexH > 0) {
            filters.value[indexH].filter.values = assistants.value
          }
        })
    }

    axios
      .get('/listWorkers', {
        params: {
          term: '',
          type: 'communication', /*user: JSON.parse(localStorage.getItem('userData')).id || null,*/
          rowsPerPage: 100,
        },
      })
      .then(response => {
        for (let i = 0; i < response.data.length; i++) {
          const u = response.data[i]
          const indexU = assistants.value.findIndex(el => el.id === u.id)
          if (indexU < 0) {
            assistants.value.push(u)
          }
        }
        const indexH = filters.value.findIndex(ele => ele.value === 'communication.assistant.code')
        if (indexH > 0) {
          filters.value[indexH].filter.values = assistants.value
        }
      })

    showResiliation.value = true
    const updateSettings = () => {
      // onSubmitPublication()

      axios
        .post('/store_multiple_settings', {
          settings: [{
            key: 'publication_value',
            value: store.state.app.settings.publication_value,
          }],
        })
        .then(response => {
          for (let i = 0; i < response.data.length; i++) {
            const u = response.data[i]
            const indexU = assistants.value.findIndex(el => el.id === u.id)
            if (indexU < 0) {
              assistants.value.push(u)
            }
          }
          const indexH = filters.value.findIndex(ele => ele.value === 'assistant.code')
          if (indexH > 0) {
            filters.value[indexH].filter.values = assistants.value
          }
        })

      // console.log(store.state.app.settings.publication_value)
    }

    return {
      updateSettings,
      item,
      items,
      downloadObject,
      superiors,
      tableColumns,
      isbnDialog,
      filters,
      searchQuery,
      payFilter,
      sourceFilter,
      statusFilter,
      totalItems,
      payOptions,
      planOptions,
      statusOptions,
      loading,
      options,
      rowsPerPageItems,
      accordDialog,
      signatureDialog,
      publicationTotalLocal,
      isFormActive,
      selectedRows,
      snackBarMessage,
      isSnackbarBottomVisible,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      openDialog,
      openSignatureDialog,
      openAccordDialog,
      openIsbnDialog,
      openTitleDialog,
      titleDialog,
      deleteItem,
      deleteDialog,
      changeTitle,
      attributeIsbn,
      confirmDelete,
      formatDate,
      avatarText,
      resolvePublicationRoleVariant,
      resolvePublicationRoleIcon,
      resolvePublicationStatusVariant,
      resolvePublicationStatusName,
      resolvePublicationTotalIcon,
      fetchItems, tableHeight,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiClose,
        mdiExportVariant,
        mdiAccountOutline,
        mdiPencilOutline,
        mdiCheckCircle,
        mdiCheckOutline,
        mdiCheckboxMarkedCircleOutline,
      },
    }
  },
}
</script>
<style lang="scss">
/*table {

  background-color: white;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
  display: block;
  overflow-x: scroll;
}
.v-data-table td, th {
  margin: 0;
  border: 1px solid grey;
  white-space: nowrap;
  border-top-width: 0px;
}

.v-data-table thead tr:first-child
}
.fixed-column {
  position: absolute;
  width: 5em;
  left: 0;
  top: auto;
  border-top-width: 1px;
  margin-top: -1px;
}*/
</style>
<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
